import { castArray, isString } from 'lodash-es';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ErrorTextProp = { text: string | string[] };

const ErrorText = ({ text: textProp }: ErrorTextProp) => {
  const {
    t,
    i18n: { exists },
  } = useTranslation();
  const text = isString(textProp) && exists(textProp) ? t(textProp) : textProp;

  return castArray(text).map((line, idx) => {
    const key = `${line}/${idx}`;
    return (
      <React.Fragment key={key}>
        {!!idx && <br />}
        <span>{line}</span>
      </React.Fragment>
    );
  });
};

export default ErrorText;
